import { QueryClient, useQuery } from "@tanstack/react-query";
import { PaginatedParams, PaginatedResult } from "services/@types";
import apiInputService from "services/apiInputService";
import { Sow } from "./@types";
import { useSubscription } from "store/auth/auth-store";

const fetchSOWsAdm = async (
  params: PaginatedParams
): Promise<PaginatedResult<Sow>> => {
  const sows = await apiInputService.get("/frontend/sow/admin", {
    params: { ...params },
  });
  const { data } = sows;

  return data as PaginatedResult<Sow>;
};

export const useSOWsAdmQuery = (params?: PaginatedParams, options?: any) => {
  const { subscription } = useSubscription();

  return useQuery(
    ["sowsAdm", subscription?.subscriptionId, params],
    () => fetchSOWsAdm(params),
    {
      ...options,
      enabled: !!subscription?.subscriptionId,
      keepPreviousData: true,
    }
  );
};

export const prefetchData = (
  queryClient: QueryClient,
  params: any,
  subscription: string
) => {
  queryClient.prefetchQuery(
    ["dashboard", "atvs", "department", subscription, params],
    () => fetch(params),
    {
      staleTime: 1000 * 60 * 5,
    }
  );
};
